export const getFormattedDateString = (date) => {
  const options = { year: "numeric", month: "numeric", day: "numeric" };
  const dateString = date.toLocaleDateString("en-GB", options);
  return dateString;
};
